import { render, staticRenderFns } from "./PropertyComponent.vue?vue&type=template&id=959bf2e0&scoped=true"
import script from "./PropertyComponent.vue?vue&type=script&lang=js"
export * from "./PropertyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959bf2e0",
  null
  
)

export default component.exports